import { ugcCreateValidator } from '@Pass-It-Down/passitdown-utils'


export default function ugcSaveValidator(ugc){
  return ugcCreateValidator(ugc)
}
